import { fetchProject, modifyProject } from "api/counsilors";
import ArticleDetails from "components/ArticleDetails";
import CreateArticle from "components/CreateArticle";
import CounsilorDetails from "components/Modal/CounsilorDetails";
import DeleteArticle from "components/Modal/DeleteArticle";
import {
  setCurrentPageNo,
  setLoading,
  setSelectedUser,
  setTotalPageNo,
} from "pages/ArticlesApprovalManagement/articlesSlice";
import { useEffect, useRef, useState } from "react";
import { isPermit } from "utils/permissionCheck";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ButtonComp from "themes/elements/Button";
import TabComp from "themes/elements/Tab";
import AllArticlesTable from "themes/elements/Table/AllArticlesTable";
function AllArticles() {
  const dispatch = useDispatch();
  const [filterRegion, setFilterRegion] = useState(null);
  const [create, setCreate] = useState(false);

  const [filterReason, setFilterReason] = useState(null);
  const [filterStatus, setFilterStatus] = useState({ value: 4, name: "All" });
  const [filterWard, setFilterWard] = useState(null);
  const [filterCouncillor, setFilterCouncillor] = useState(null);
  const [filterReqCouncillor, setFilterReqCouncillor] = useState(null);
  const [isEdit, setEdit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [details, setDetails] = useState(false);
  const [filterTerm, setFilterTerm] = useState();
  const [tabActive, setTabActive] = useState("1");
  const [isDetailsModal, setIsDetailsModal] = useState(false);
  const [filterDate, setFilterDate] = useState(null);
  const [articlesData, setArticlessData] = useState([]);
  const isFirstLoad = useRef(true);

  const getColumnData = (activeTab) => {
    const baseColumns = [
      {
        title: "Title",
        key: "title",
        filter: "searchTitle",
        width: 270,
      },
      {
        title: "WARD",
        key: "ward_code",
        filter: "searchNumber",
        width: 120,
      },
      {
        title: "COUNCILLOR",
        key: "created_user_name",
        filter: "searchCouncillor",
        width: 270,
      },
    ];

    const dateColumn = {
      title: "", // Placeholder title that will be updated
      key: "", // Placeholder key that will be updated
      filter: "dateChange",
      width: 180,
    };

    switch (activeTab) {
      case 1: // Published
        dateColumn.title = "PUBLISHED ON";
        dateColumn.key = "published_date";
        break;
      case 2: // Submitted
        dateColumn.title = "SUBMITTED ON";
        dateColumn.key = "submitted_date";
        break;
      case 3: // Rejected
        dateColumn.title = "REJECTED ON";
        dateColumn.key = "rejected_on";
        break;
      case 4: // Draft
        return baseColumns; // No date for drafts, keep base columns only
      default:
        return baseColumns; // Default to minimal configuration without date
    }

    // Insert the date column as the second item for cases 1, 2, 3
    return [
      baseColumns[0], // Title column
      dateColumn, // Date column
      ...baseColumns.slice(1), // Remaining columns
    ];
  };

  const columns = getColumnData(Number(tabActive));
  const { isLoading, selectedUser, currentPageNo, totalPageNo } = useSelector(
    (state) => state.projects
  );

  const loadProjects = async () => {
    dispatch(setLoading(true));

    try {
      const params = {
        page: currentPageNo,
        perPage: 10,
        status:
          tabActive === "1"
            ? 2
            : tabActive === "2"
            ? 1
            : tabActive === "3"
            ? 3
            : 0,

        title: filterRegion ? filterRegion : "",
        councilorName: filterCouncillor && filterCouncillor,
        wardCode: filterWard && Number(filterWard),
      };

      if (tabActive === "3") {
        params.rejectedDate = filterDate;
      } else if (tabActive === "2") {
        params.submittedDate = filterDate;
      } else if (tabActive === "1") {
        params.publishedDate = filterDate;
      }

      const articles = await fetchProject(params);
      if (articles?.meta) {
        setArticlessData(articles?.projects);

        if (currentPageNo === 1) {
          dispatch(setTotalPageNo(articles.meta.last_page * 10));
          dispatch(setCurrentPageNo(1));
          // Changed to totalPages, if your API returns total pages directly, use that instead of last_page * 10
        } else {
          dispatch(setCurrentPageNo(articles.meta.current_page));
        } // Use currentPage directly if it's provided
      }

      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    dispatch(setCurrentPageNo(1)); // Set the page number to 1
  }, [dispatch]);

  useEffect(() => {
    if (currentPageNo === 1 && isFirstLoad.current) {
      loadProjects(); // Trigger the initial data load after currentPageNo is set
      isFirstLoad.current = false; // Set first load flag to false
    }
  }, [currentPageNo]);

  useEffect(() => {
    if (!isFirstLoad.current) {
      loadProjects();
    }
  }, [
    currentPageNo,
    tabActive,
    filterTerm,
    filterReason,
    filterWard,
    filterCouncillor,
    filterRegion,
    filterStatus,
    filterDate,
    filterReqCouncillor,
    create,
  ]);

  const tabsData = [
    {
      key: "1",
      label: "Published",
      children: (
        <>
          {tabActive === "1" && (
            <AllArticlesTable
              filterDate={filterDate}
              setFilterDate={setFilterDate}
              isLoading={isLoading}
              column={columns}
              data={articlesData}
              filterRegion={filterRegion}
              setFilterRegion={setFilterRegion}
              filterWard={filterWard}
              setFilterWard={setFilterWard}
              filterCouncillor={filterCouncillor}
              setFilterCouncillor={setFilterCouncillor}
              onDeleteAction={(data) => {
                setIsDelete(true);
                dispatch(setSelectedUser(data));
              }}
              dataClick={(data) => {
                dispatch(setSelectedUser(data));
              }}
              approve
              totalPageNo={totalPageNo}
              currentPageNo={currentPageNo}
              filterTerm={filterTerm}
              setFilterTerm={setFilterTerm}
              setFilterReason={setFilterReason}
              filterReason={filterReason}
              filterStatus={filterStatus}
              setFilterStatus={setFilterStatus}
              setIsDetails={setIsDetailsModal}
              setFilterReqCouncillor={setFilterReqCouncillor}
              filterReqCouncillor={filterReqCouncillor}
              setDetails={setDetails}
            />
          )}
        </>
      ),
    },
    {
      key: "2",
      label: "Submitted",
      children: (
        <>
          {tabActive === "2" && (
            <AllArticlesTable
              filterDate={filterDate}
              setFilterDate={setFilterDate}
              isLoading={isLoading}
              column={columns}
              data={articlesData}
              filterRegion={filterRegion}
              setFilterRegion={setFilterRegion}
              filterWard={filterWard}
              setFilterWard={setFilterWard}
              filterCouncillor={filterCouncillor}
              setFilterCouncillor={setFilterCouncillor}
              dataClick={(data) => {
                dispatch(setSelectedUser(data));
              }}
              onDeleteAction={(data) => {
                setIsDelete(true);
                dispatch(setSelectedUser(data));
              }}
              handleEdit={(data) => {
                setIsDelete(true);
                dispatch(setSelectedUser(data));
              }}
              setFilterReason={setFilterReason}
              totalPageNo={totalPageNo}
              currentPageNo={currentPageNo}
              filterTerm={filterTerm}
              setFilterTerm={setFilterTerm}
              filterStatus={filterStatus}
              setFilterStatus={setFilterStatus}
              setIsDetails={setIsDetailsModal}
              setFilterReqCouncillor={setFilterReqCouncillor}
              filterReqCouncillor={filterReqCouncillor}
              setDetails={setDetails}
            />
          )}
        </>
      ),
    },
    {
      key: "3",
      label: "Rejected",
      children: (
        <>
          {tabActive === "3" && (
            <AllArticlesTable
              filterDate={filterDate}
              setFilterDate={setFilterDate}
              isLoading={isLoading}
              column={columns}
              data={articlesData}
              filterRegion={filterRegion}
              setFilterRegion={setFilterRegion}
              filterWard={filterWard}
              setFilterWard={setFilterWard}
              filterCouncillor={filterCouncillor}
              setFilterCouncillor={setFilterCouncillor}
              dataClick={(data) => {
                dispatch(setSelectedUser(data));
              }}
              onDeleteAction={(data) => {
                setIsDelete(true);
                dispatch(setSelectedUser(data));
              }}
              setFilterReason={setFilterReason}
              totalPageNo={totalPageNo}
              currentPageNo={currentPageNo}
              filterTerm={filterTerm}
              setFilterTerm={setFilterTerm}
              filterStatus={filterStatus}
              setFilterStatus={setFilterStatus}
              setIsDetails={setIsDetailsModal}
              setFilterReqCouncillor={setFilterReqCouncillor}
              filterReqCouncillor={filterReqCouncillor}
              setDetails={setDetails}
            />
          )}
        </>
      ),
    },
    {
      key: "4",
      label: "Drafts",
      children: (
        <>
          {tabActive === "4" && (
            <AllArticlesTable
              editAction
              filterDate={filterDate}
              setFilterDate={setFilterDate}
              isLoading={isLoading}
              column={columns}
              data={articlesData}
              filterRegion={filterRegion}
              setFilterRegion={setFilterRegion}
              filterWard={filterWard}
              setFilterWard={setFilterWard}
              filterCouncillor={filterCouncillor}
              setFilterCouncillor={setFilterCouncillor}
              dataClick={(data) => {
                dispatch(setSelectedUser(data));
              }}
              onDeleteAction={(data) => {
                setIsDelete(true);
                dispatch(setSelectedUser(data));
              }}
              handleEdit={(data) => {
                setCreate(true);
                setEdit(true);
                dispatch(setSelectedUser(data));
              }}
              setFilterReason={setFilterReason}
              totalPageNo={totalPageNo}
              currentPageNo={currentPageNo}
              filterTerm={filterTerm}
              setFilterTerm={setFilterTerm}
              filterStatus={filterStatus}
              setFilterStatus={setFilterStatus}
              setIsDetails={setIsDetailsModal}
              setFilterReqCouncillor={setFilterReqCouncillor}
              filterReqCouncillor={filterReqCouncillor}
              setDetails={setDetails}
            />
          )}
        </>
      ),
    },
  ];

  function handleTabChange(key) {
    setArticlessData([]);
    dispatch(setCurrentPageNo(1));
    setFilterDate(null);
    setTabActive(key);
    setFilterRegion("");
    setFilterWard("");
    setFilterTerm();
    setFilterCouncillor("");
    setFilterReason();
    setFilterReqCouncillor();
  }

  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  const deleteArticleData = async () => {
    // Define the payload for the delete request
    const payload = {
      councilorId: selectedUser.councilor_id,
      wardCode: selectedUser.ward_code,
      title: selectedUser.ward_code,
      description: selectedUser.description ? selectedUser.description : "",
      content: selectedUser.project_content,
      objectCount: 0,
      status: 0,
      action: "delete",
      councilorProjectId: selectedUser.councilor_project_id,
    };

    // Loader state to show while the API call is in progress
    setIsDeleteLoading(true); // Make sure you define `setLoading` using `useState` in your component

    try {
      // Call the modifyProject API with the payload
      const response = await modifyProject(payload);
      // If successful, show a success message
      if (response) {
        dispatch(setCurrentPageNo(1));

        toast.success(response.message);
        setIsDelete(false);
        if (currentPageNo === 1) {
          loadProjects();
        }
      }
    } catch (error) {
      // If there's an error, show an error message
    } finally {
      dispatch(setCurrentPageNo(1));

      setDetails(false);
      setIsDelete(false);
      setIsDelete(false);
      // Hide the loader after API call completion
      setIsDeleteLoading(false);
    }
  };

  return (
    <div className="page-wrapper flex flex-column gap-4">
      <>
        {create ? (
          <CreateArticle
            setTabActive={setTabActive}
            loadProjects={loadProjects}
            setOpen={setCreate}
            open={create}
            // categoryData={categoryData}
            // setLoadCategory={setLoadCategory}
            selectedArticle={selectedUser}
            isEdit={isEdit}
            handleTabChange={handleTabChange}
            setCreate={setCreate}
            // setDetails={setDetails}
          />
        ) : details ? (
          <ArticleDetails
            setIsDelete={setIsDelete}
            isDeleteLoading={isDeleteLoading}
            deleteArticleData={deleteArticleData}
            onEdit={(data) => {
              dispatch(setSelectedUser(data));
            }}
            setOpen={setDetails}
            fetchNews={loadProjects}
            selectedArticle={selectedUser}
            tabActive={tabActive}
          />
        ) : (
          <>
            <div className="flex wrap gap-2 align-center justify-between">
              <h2 className="page-title">All articles</h2>
              {isPermit(8, "create") && (
                <ButtonComp
                  disabled={isLoading}
                  onClick={() => {
                    dispatch(setSelectedUser());

                    setCreate(true);
                    setEdit(false);
                  }}
                  prefix
                >
                  Add new
                </ButtonComp>
              )}
            </div>
            {isPermit(8, "view") && (
              <TabComp
                isLoading={isLoading}
                tabActive={tabActive}
                handleTabChange={handleTabChange}
                // exportData={selectedData}
                // count={selectedData?.length}
                data={tabsData}
              />
            )}
          </>
        )}

        <DeleteArticle
          isDeleteLoading={isDeleteLoading}
          setIsDelete={setIsDelete}
          isDelete={isDelete}
          selectedData={selectedUser}
          data={selectedUser}
          handleDeleteArticle={deleteArticleData}
        />
        <CounsilorDetails
          tabActive={tabActive}
          setDetails={setIsDetailsModal}
          isDetails={isDetailsModal}
          selectedData={selectedUser}
          data={selectedUser}
        />
      </>
    </div>
  );
}

export default AllArticles;
